import { useEffect, useState } from 'react';

export function useTitle(title: string | null | undefined): void {
  useEffect(() => {
    document.title = title ? `${title} | Project R` : 'Project R | Classic MMORPG adventure, anywhere you play';
  }, [title]);
}

/** Re-renders every `ms` with the current time (for countdowns). */
export function useNow(ms = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(t);
  }, [ms]);
  return now;
}
